import { render, staticRenderFns } from "./CustomShapeToolboxTemplate.vue?vue&type=template&id=615b018e&"
import script from "./CustomShapeToolboxTemplate.vue?vue&type=script&lang=js&"
export * from "./CustomShapeToolboxTemplate.vue?vue&type=script&lang=js&"
import style0 from "./CustomShapeToolboxTemplate.vue?vue&type=style&index=0&scopded=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports